import React from "react";
import MainPage from "../04-templates/MainPage/MainPage";

const SecondPage = (): JSX.Element => <MainPage displayMode="controls" />;

export default SecondPage;
